import { render } from "./BackerCenterRecentlyViewedProjectsSkeleton.vue?vue&type=template&id=4caf96e6"
import script from "./BackerCenterRecentlyViewedProjectsSkeleton.vue?vue&type=script&lang=js"
export * from "./BackerCenterRecentlyViewedProjectsSkeleton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__